import React from 'react';
import { CarouselDisplayStyle } from '@honeycomb/data';
import { Stacker, Styler, TypographyBody, TypographyHero } from '@honeycomb/ui-core';
import { useGenericRootComponent } from './GenericRootComponent/GenericRootComponent.context';
export function SectionHeading({ sectionHeading: { heading, subheading, __typename }, alias, }) {
    const { carouselDisplayStyle, textColor } = useGenericRootComponent();
    if (!heading) {
        return null;
    }
    const isAdjacentLayout = carouselDisplayStyle === CarouselDisplayStyle.Adjacent;
    const content = (React.createElement(Stacker, { spacing: { xs: 2, xl: 3 }, px: { l: 10 }, pl: isAdjacentLayout ? { l: 0 } : undefined, mb: 8, alignItems: isAdjacentLayout ? { xs: 'center', l: 'flex-start' } : 'center', ta: isAdjacentLayout ? { xs: 'center', l: 'start' } : 'center', c: textColor },
        React.createElement(TypographyHero, { color: textColor !== null && textColor !== void 0 ? textColor : 'text.heading', component: "h2", size: "2xl", "data-id": `${__typename}-${alias}` }, heading),
        subheading && (React.createElement(TypographyBody, { color: textColor !== null && textColor !== void 0 ? textColor : 'text.heading', size: "l", "data-id": `subheading-${alias}` }, subheading))));
    if (isAdjacentLayout) {
        return (React.createElement(Styler, { pos: "relative", zIndex: 2 }, content));
    }
    return content;
}
